const InputError = () => {
    return <p className="error">For General Information, please select a U.S. state & at least one (1) activity</p>
};

export default InputError;